define('boxes/login-box',['jquery', 'boxes/box', 'boxes/events/loginEvent', 'boxes/helpers/loginHelper', 'all/jquery/jquery.validate', 'boxes/helpers/box-loading', 'realityCheck'],
	function ($, box, loginEvent, loginHelper, validate, boxLoading, realityCheck) {
    'use strict';

    var loginDoneCallback = function (){};
	var loginBoxObject = null;

    function validateCaptchaBoxIfEnabled(loginBox) {
        var value = $.cookie('0bf04cf90ac495ebce851f21d27d92de3792aaf32b67728b0ab35c7a5d');
        if (value === '49d54f8eca97d64b06a4da452das0c26ad62930b615ab795ba2cd136d3') {
            grecaptcha.execute();
        } else {
			//if captcha is not enabled for whitelisted countries then we will do a direct login
			submitFormAfterValidation(loginBox);
		}
    }

	function submitFormAfterValidation(loginBox) {
		disableLoginButton(loginBox);
		FSJSC_profile(loginBox,setDeviceIdSubmitCallBack)
	}

	function validateFormThroughCaptcha(loginBox) {
		window.isLoginBox = true;
		validateCaptchaBoxIfEnabled(loginBox);
	}

    function init(loginBox) {
		loginBoxObject = loginBox;

        loginBox.$controller.on(loginEvent.SET_LOGIN_DONE_CALLBACK, function (event, loginDoneCallbackRef) {
            event.preventDefault();
            loginDoneCallback = loginDoneCallbackRef;
        });

		var $loginButton = loginBox.$box.find('.loginbutton');
		$loginButton.click(function () {
			validateFormThroughCaptcha(loginBox);
        });

        loginBox.$box.find('a.forgotPasswordLink').click(function (event) {
            event.preventDefault();
            loginBox.$controller.trigger(loginEvent.FORGOT_PASSWORD);
            loginBox.$controller.goToBox(loginBox.$controller.boxes[2]);
        });

        var $form = loginBox.$box.find('form');
        setupValidationConfiguration($form);

        var $elements = loginBox.$box.find(':input');
        loginHelper.setupFocusPopover($elements);

        $form.find(':text,:password').each(
            function () {
                var $text = $(this);

                $text.keypress(function (e) {
                    // support enter without having actual submit button
                    if (e.which === 13) {
                        e.preventDefault();
						if($loginButton.prop('disabled') !== true){
							$loginButton.click();
						}
                    }
                });
            }
        );

    }

	function setDeviceIdSubmitCallBack(loginBox, fingerprint){
		window.isLoginBox = false;
		var userName = loginBox.$box.find('input[name=PARAM_USER_NAME]').filter(':visible').val();
		var password = loginBox.$box.find('input[name=PARAM_PASSWORD]').filter(':visible').val();
		var captchaCode = $.cookie("captcha");
		boxLoading.showLoading(loginBox.$box);
		$.post('/pp?flow=LoginJson', {
			PARAM_USER_NAME: userName,
			PARAM_PASSWORD: password,
			PARAM_DEVICE_ID_HASH_CODE: generateHashCode (fingerprint),
            PARAM_CAPTCHA_CODE: captchaCode
		}, function (data) {
			loginSuccess(data, loginBox);
		});
	}

	function generateHashCode(strObject) {
        var strArray = Object.keys(strObject).map(function(e) {
            return strObject[e]
        })
		var strConcat = strArray.join();
		var hash = 0,
			i,
			chr;
		if (strConcat.length === 0) return hash;
		for (i = 0; i < strConcat.length; i++) {
			chr = strConcat.charCodeAt(i);
			hash = (hash << 5) - hash + chr;
			hash |= 0; // Convert to 32bit integer
		}
		return hash;
	}

    function setupValidationConfiguration($form) {

        var validationConfiguration = {
            errorClass: loginHelper.ERROR_CLASS,
            validClass: loginHelper.VALID_CLASS,
            rules: {
                PARAM_USER_NAME: {
                    required: true,
                    minlength: 5,
                    maxlength: 30
                },
                PARAM_PASSWORD: {
                    required: true,
                    minlength: 5,
                    maxlength: 30
                }
            },
            highlight: loginHelper.highlight,
            unhighlight: loginHelper.unHighlight,
            errorPlacement: loginHelper.errorPlacement
        };

        $form.validate(validationConfiguration);

    }



    function mustChangePassword(response) {
        return 'true' === response.PARAM_MUST_CHANGE_PW;
    }


	function disableLoginButton(loginBox) {
		loginBox.$box.find('.loginbutton').prop('disabled', true);
	}

	function enableLoginButton(loginBox) {
		loginBox.$box.find('.loginbutton').prop('disabled', false);
	}

	function failLogin(response, loginBox) {

        if ('SYSTEM_ERROR' === response.RESULT) {
            loginHelper.showOneButtonPopup(loginBox, response.ERROR_HEADER, response.ERROR, response.BUTTON_TEXT, function(){
				enableLoginButton(loginBox);
			});
            return;
        }

        if (response.ACC_LOCKED_STATUS) {
            // CLOSED_USER_REQUEST (3), CLOSED_RES_GAMING (6), CLOSED_UK_NOT_RES_GAMING(8)
            if ('3' === response.ACC_LOCKED_STATUS || '6' === response.ACC_LOCKED_STATUS || '8' === response.ACC_LOCKED_STATUS) {
                // TODO: Replace showInfoMessageGeneric call, server side creates some html to be shown, must change on serverside
				enableLoginButton(loginBox);
                window.showInfoMessageGeneric(response.POPUP_BODY, true, null, null, response.LOGIN_FAIL_RESP_GAMING_HEADER);
            } else {
                loginHelper.showOneButtonPopup(loginBox, response.ERROR_HEADER, response.ERROR, response.BUTTON_TEXT, function(){
					enableLoginButton(loginBox);
				});
            }
        } else {
            loginHelper.showOneButtonPopup(loginBox, response.ERROR_HEADER, response.ERROR, response.BUTTON_TEXT, function(){
				enableLoginButton(loginBox);
			});
        }
    }


    function loginSuccess(response, loginBox){
        console.log('login.ajaxSuccess', response);
        boxLoading.removeLoading(loginBox.$box);
        if (response.RESULT === 'OK') {
			realityCheck.startRealityCheck ();

            if (mustChangePassword(response)) {
				var userName = loginBox.$box.find('input[name=PARAM_USER_NAME]').filter(':visible').val();
				var password = loginBox.$box.find('input[name=PARAM_PASSWORD]').filter(':visible').val();
				var loginData = { "uName": userName, "tempPass": password };
                loginBox.$controller.trigger(loginEvent.CHANGE_PASSWORD, loginData);
                loginBox.$controller.nextBox();
            } else if (response.HAVE_NOT_SEEN_POPUP) {
                // TODO: Maybe use showTCPopup of login.js here?
				enableLoginButton(loginBox);
                showTCPopup(response);
				$('#sliding-content-wrapper').find('.close').click();
            } else {
                loginDoneCallback(response);
            }
        } else {
			failLogin (response, loginBox);
        }
		grecaptcha.reset();
		$.removeCookie("captcha");
	}

    function showTCPopup(response) {
        var data = {
            heading: response.TERMS_UPDATED_HEADER,
            message: response.TERMS_UPDATED,
            confirm: response.AGREE,
            username: response.PARAM_USER_NAME,
            password: response.PARAM_PASSWORD,
			captcha: $.cookie ("captcha"),
            rememberme: true,
            termsagreed: true
        };
        dialog.load('TermsAndConditions', data, undefined, undefined);
    }

	window.captchaSubmitLoginBox = function() {
		submitFormAfterValidation(loginBoxObject);
	};

    var view = {
            render: function () {}
        },
        model = {
            init: function (loginBox) {
                init(loginBox);
            },
            beforeRender: function () {},
            afterRender: function (loginBox) {
                enableLoginButton(loginBox);
            }
        };

    return {
        create: function ($box, $controller) {
            return box.create($box, $controller, view, model);
        }
    };
});

